import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExpedienteDto } from '../../../dto/expediente/expediente.dto';
import { ExpedienteService } from '../../../services/expediente.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { Constants } from '../../../constants/constants';
import { PowerbiService } from '../../../services/powerbi.service';
import { RequestFiltersContarDatos } from '../../../dto/powerbi/request.filters.contardatos.dto';
import { ResponseEmbedconfigDto } from '../../../dto/powerbi/response.embedconfig.dto';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-procesos-ica',
  templateUrl: './procesos-ica.component.html',
  styleUrl: './procesos-ica.component.scss',
})
export class ProcesosIcaComponent implements OnInit {
  // Number
  private entidadId: number;
  // Form
  public form!: FormGroup;
  // String
  public proceso = '';
  // DTO
  public dataExpediente: ExpedienteDto | undefined;
  // Boolean
  public showResult = false;
  public notFound = false;

  yearsFilter: number[] = [];
  currentYear = new Date().getFullYear();
  selectedYear: number;

  //Reportes PowerBI
  embedUrl!: string;
  embedToken!: string;
  accessToken!: string;
  reportId!: string;
  groupId!: string;
  renderizarReporte = false;

  // Multilenguaje
  tableText: any = {};
  procesosText: any = {};
  nombreEntidad: string = '';
  constructor(
    private readonly fb: FormBuilder,
    private readonly expedienteService: ExpedienteService,
    private readonly alertaModalService: AlertaModalService,
    private readonly pbiService: PowerbiService,
    private readonly translate: TranslateService
  ) {
    this.entidadId = Constants.ID_ENTIDAD_ICA;
    this.selectedYear = this.currentYear;
    // Multilenguaje
    this.translate.stream('proceso-ICA').forEach(text => {
      for (let key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }
    });
    this.translate.stream('procesos-comun').forEach(text => {
      for (let key of Object.keys(text)) {
        this.procesosText[key] = text[key];
      }
    });
  }

  ngOnInit(): void {
    this.obtenerEntidad();
    this.buildForm();
    for (let i = 0; i < 5; i++) {
      const yearAdd = this.currentYear - i;
      this.yearsFilter.push(yearAdd);
    }

    this.pbiService
      .getReporte('ICA')
      .subscribe((data: ResponseEmbedconfigDto) => {
        this.embedUrl = data.reportDetails.embedUrl;
        this.embedToken = data.embedToken.token;
        this.accessToken = data.accessToken;
        this.reportId = data.reportDetails.id;
        this.groupId = data.reportDetails.workspaceId;
        this.renderizarReporte = true;
      });
  }

  buildForm() {
    this.form = this.fb.group({
      numeroProceso: ['', Validators.required],
    });
  }

  buscarExpediente() {
    const numeroProceso = this.form.get('numeroProceso')?.value;
    if (numeroProceso) {
      this.expedienteService
        .getExpedienteByProceso(this.entidadId, numeroProceso)
        .subscribe(
          (response: ExpedienteDto) => {
            this.dataExpediente = response;
            this.proceso = this.dataExpediente.Radicado!;
            this.showResult = true;
            this.notFound = false;
          },
          error => {
            console.error(error);
            this.showResult = false;
            this.notFound = true;
            this.alertaModalService.error(this.tableText['no-existe-proceso']);
          }
        );
    } else {
      console.error(this.procesosText['digite-numero']);
      this.alertaModalService.error(this.procesosText['digitar-proceso']);
    }
  }

  downloadExcel() {
    const filters: RequestFiltersContarDatos[] = [
      {
        name: 'Filtro_Year',
        value: this.selectedYear,
      },
    ];
    this.pbiService.exportExcel(filters, 'ICA').subscribe(
      (response: Blob) => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'Contar_Datos_ICA.xlsx'; // Nombre del archivo que se descargará
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(anchor);
        if (response) {
          this.alertaModalService.exito(
            this.tableText['exito'],
            this.tableText['descarga-archivo']
          );
        }
      },
      error => {
        this.alertaModalService.error(this.tableText['error-descarga']);
      }
    );
  }
  obtenerEntidad(): void {
      const id = this.entidadId;
      this.expedienteService.getEntidadById(id).subscribe({
        next: (data) => {
          this.nombreEntidad = data.Entidad;
        },
        error: (err) => {
            console.error('Error al obtener entidad:', err);
          }
      });
    }
}
